import {IStorage} from '@src/@interfaces/services/Storage/IStorage';
import {IStorageDriver} from '@src/@interfaces/services/Storage/IStorageDriver';
import TemporaryStorage from './drivers/TemporaryStorage';
import {IListener, ISubscription} from '@src/@interfaces/services/Events';
import {IEventEmitter} from '@src/@interfaces/services/Events/IEventEmitter';
import EventEmitter from '@src/services/Events/EventEmitter';

const defaultStorageDriver = window?.localStorage ?? new TemporaryStorage();

export default class Storage extends EventEmitter<'changed'> implements IStorage, IEventEmitter {
    constructor(
        protected readonly prefix: string = '',
        protected readonly driver: IStorageDriver = defaultStorageDriver
    ) {
        super();
    }

    get(name: string): string | null {
        return this.driver.getItem(this.prefix + name);
    }

    has(name: string): boolean {
        return this.get(name) !== null;
    }

    set(name: string, value: string): void {
        this.driver.setItem(this.prefix + name, value);
        this.emit('changed', {name, realName: this.prefix + name, value});
    }

    remove(name: string): void {
        this.driver.removeItem(this.prefix + name);
        this.emit('changed', {name, realName: this.prefix + name, value: null});
    }

    getList(): Record<string, string> {
        const result: Record<string, string> = {};
        for (let i = 0; i < this.driver.length; i++) {
            const key = this.driver.key(i);
            if (key && key.startsWith(this.prefix)) {
                result[key.replace(this.prefix, '')] = this.driver.getItem(key) as string;
            }
        }

        return result;
    }

    onChanged(listener: IListener<{ name: string, realName: string, value: string | null }>): ISubscription {
        return this.on('changed', listener);
    }

    clear(): void {
        for (let i = 0; i < this.driver.length; i++) {
            const key = this.driver.key(i);
            if (key && key.startsWith(this.prefix)) {
                this.remove(
                    key.substring(this.prefix.length)
                );
            }
        }
    }
}
